import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

import { keepPreviousData, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

import { App } from './App'

import { Article } from '#/view/Article'
import { Category } from '#/view/Category'
import { Eshop } from '#/view/Eshop'
import { NoResult } from '#/view/NoResult'
import { Rental } from '#/view/Rental'
import { Season } from '#/view/Season'

import { Config } from '#/global/helper/Config'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity, // vypnutí refetch při procházení. Znovu se to fetchne při f5
            gcTime: Infinity,
            refetchOnWindowFocus: false,
            placeholderData: keepPreviousData,
            retry: false,
        },
    },
})
/**
 * for localhost development
 */
if (import.meta.env.DEV && window.location.hostname === 'localhost' && !window.location.search) {
    window.location.href = `pobocka-${Config.getBranchTitle()}/search/eshop?query=cihla`
}

const router = createBrowserRouter(
    [
        {
            path: '/:branchTitle?/search',
            element: <App />,
            children: [
                {
                    path: 'eshop',
                    element: <Eshop />,
                },
                {
                    path: 'rental',
                    element: <Rental />,
                },
                {
                    path: 'category',
                    element: <Category />,
                },
                {
                    path: 'article',
                    element: <Article />,
                },
                {
                    path: 'season',
                    element: <Season />,
                },
            ],
        },
        {
            path: '/:branchTitle?/search/no-result',
            element: <NoResult />,
        },
    ],
)

ReactDOM.createRoot(document.querySelector('#r-a-search')!).render(
    <StrictMode>
        <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
            <ReactQueryDevtools />
        </QueryClientProvider>
    </StrictMode>,
)
